module.exports = __webpack_public_path__ + "assets/img/INTERIOR11.6d3d552e.png";